import { render } from "./SchemeMaster.vue?vue&type=template&id=8bea5294&scoped=true"
import script from "./SchemeMaster.vue?vue&type=script&lang=js"
export * from "./SchemeMaster.vue?vue&type=script&lang=js"

import "./SchemeMaster.vue?vue&type=style&index=0&id=8bea5294&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bea5294"]])

export default __exports__